import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { USER_INFO } from './constants';
import {
  UserInfoSuccess,
  UserInfoError,
  UserInfoActionTypes,
  IUserInfoState,
} from './types';

const initialState: IUserInfoState = {
  status: idle,
  entities: null,
  error: null,
};

export default produce(
  (draft = initialState, action: UserInfoActionTypes): IUserInfoState => {
    switch (action.type) {
      case USER_INFO + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case USER_INFO + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as UserInfoSuccess).payload;
        break;
      }
      case USER_INFO + FAILURE: {
        draft.status = rejected;
        draft.error = (action as UserInfoError).error;
        break;
      }
      case USER_INFO + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
